"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = GDLogo;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _link = _interopRequireDefault(require("@ux/link"));
var _logoHooks = require("@ux/logo-hooks");
var _goLogo = _interopRequireDefault(require("./goLogo.js"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * Renders shared GD logo.
 *
 * @param {Object} props Properties
 * @returns {React.ReactElement} shared logo
 * @public
 */
function GDLogo(props) {
  var defaultProps = _objectSpread({
    collapsedLogo: false,
    country: '',
    market: 'en-US',
    showCountryNameOnLogo: false,
    urlArgs: {}
  }, props);
  var isMobile = (0, _logoHooks.useMobile)(props);
  var tempLogo = (0, _logoHooks.useTemporaryLogo)(defaultProps);
  // render an alternate logo if the timeframe applies
  if (tempLogo) return tempLogo;
  var logo = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, defaultProps.market !== 'en-US' && defaultProps.showCountryNameOnLogo && /*#__PURE__*/_react["default"].createElement("span", {
    className: "topnav-country"
  }, defaultProps.country), /*#__PURE__*/_react["default"].createElement("figure", {
    style: {
      margin: 0
    },
    className: (0, _classnames["default"])('go-logo', isMobile ? 'mobile-logo' : 'desktop-logo', defaultProps.figClass),
    "aria-label": "GoDaddy"
  }, isMobile ? _goLogo["default"].mobile : _goLogo["default"].desktop));
  return defaultProps.href ? /*#__PURE__*/_react["default"].createElement(_link["default"], {
    className: defaultProps.className,
    urlArgs: defaultProps.urlArgs,
    "data-eid": defaultProps['data-eid'],
    onClick: defaultProps.onClick,
    href: (0, _logoHooks.updateQuery)(defaultProps.href, defaultProps.urlArgs)
  }, logo) : logo;
}
GDLogo.propTypes = {
  /** CSS class name to apply to the outer element */
  'className': _propTypes["default"].string,
  /** use the mobile logo at all breakpoints */
  'collapsedLogo': _propTypes["default"].bool,
  /** Current country name. Required. */
  'country': _propTypes["default"].string,
  /** Unique id used for Traffic 2 ie: 'your.product.godaddy.preformatted.eid_value.click' */
  'data-eid': _propTypes["default"].string,
  /** href to pass to Link component */
  'href': _propTypes["default"].string,
  /** Current market. */
  'market': _propTypes["default"].string,
  /** Callback for a click on the logo link */
  'onClick': _propTypes["default"].func,
  /** false in the US market and tablet and mobile, otherwise based on showCountryNameOnLogo in utility-bar */
  'showCountryNameOnLogo': _propTypes["default"].bool,
  /** CSS class name to apply to wrapping `figure` element */
  'figClass': _propTypes["default"].string,
  /** An object with specifications for a temporary alternate logo */
  'tempLogo': _propTypes["default"].object,
  /** An object with arguments being passed to `Link` component to generate correct `href` */
  'urlArgs': _propTypes["default"].object,
  /** An object with arguments being passed to `Link` component to generate correct `href` */
  'urls': _propTypes["default"].shape({
    cdn: _propTypes["default"].shape({
      href: _propTypes["default"].string
    })
  })
};